'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { memo } from 'react'

import { SalesItemTypes } from '@/entities/sales'

import { BASE_URL } from '@/shared/lib/const/env'
import { getBotInfo } from '@/shared/lib/seo'
import { timeFormatter } from '@/shared/lib/utils/date/timeFormatter'
import { Button } from '@/shared/ui'
import { ElementsSliderFree } from '@/shared/ui/elements-slider-free'

import cl from './SalesList.module.scss'

interface SalesListProps {
	sales: SalesItemTypes[]
}

export const SalesList = memo((props: SalesListProps) => {
	const { sales = [] } = props

	const salesToShow = sales.filter(item => !item.HIDE_ON_LIST)

	const router = useRouter()

	const onClick = () => {
		router.push('/sales')
	}

	return (
		<div className={cl.root}>
			<div className={cl.content}>
				<div className={cl.content__header}>
					<h2>Акции</h2>
					<Link href="/sales" prefetch={false}>
						Все акции
					</Link>
				</div>

				<div className={cl.content__desktop}>
					<ElementsSliderFree classNameRoot={cl.elementsSlider} classNameSlide={cl.slide}>
						{salesToShow.map(item => (
							<SaleArticle
								key={item.ID}
								code={item.CODE}
								image={item.PREVIEW_PICTURE || `/error`}
								title={item.NAME}
								activeTo={item.ACTIVE_TO}
								customLink={item.CUSTOM_LINK}
							/>
						))}
					</ElementsSliderFree>
				</div>

				<div className={cl.content__mobile}>
					{salesToShow.slice(0, 2).map(item => (
						<SaleArticle
							key={item.ID}
							code={item.CODE}
							image={item.PREVIEW_PICTURE}
							title={item.NAME}
							activeTo={item.ACTIVE_TO}
							customLink={item.CUSTOM_LINK}
						/>
					))}

					<Button theme="secondary" fullWidth onClick={onClick}>
						Все акции
					</Button>
				</div>
			</div>
		</div>
	)
})

interface SaleArticleProps {
	code: string
	image: string
	title: string
	activeTo: string
	customLink?: string
}

export const SaleArticle = (props: SaleArticleProps) => {
	const { code, image, title, activeTo, customLink } = props

	const isBot = getBotInfo('isDetected')

	if (customLink) {
		return (
			<a href={customLink} target="_blank" rel="noopener noreferrer">
				<article className={cl.article}>
					<div className={cl.article__image}>
						<Image
							src={`${BASE_URL}${image}`}
							priority={isBot}
							width={1440}
							height={552}
							sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px"
							alt={title}
							draggable={false}
						/>
					</div>
					<p className={cl.title}>{title}</p>
					<p className={cl.endDate}>акция до {timeFormatter(activeTo)}</p>
				</article>
			</a>
		)
	}

	return (
		<Link href={`/sales/${code}`} prefetch={false}>
			<article className={cl.article}>
				<div className={cl.article__image}>
					<Image
						src={`${BASE_URL}${image}`}
						priority={isBot}
						width={1440}
						height={552}
						sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px"
						alt={title}
						draggable={false}
					/>
				</div>
				<p className={cl.title}>{title}</p>
				<p className={cl.endDate}>акция до {timeFormatter(activeTo)}</p>
			</article>
		</Link>
	)
}
